<template>
  <div class="flex flex-col lg:flex-row overflow-hidden">
    <div data-aos="zoom-in-right" data-aos-duration="700" class="lg:w-1/2">
      <ClientOnly>
        <swiper-container ref="containerRef" :init="false" class="h-full">
          <swiper-slide v-for="index in imageCount" :key="index">
            <img class="object-cover w-full h-full" :src="`/images/events/event_1/${index}.jpg`" alt="Event Image" />
          </swiper-slide>
        </swiper-container>
      </ClientOnly>
    </div>

    <div data-aos="zoom-in-left" data-aos-duration="700"
      class="lg:w-1/2 p-10 px-6 md:p-20 flex flex-col justify-center">
      <p class="pb-6 text-xl md:text-2xl font-serif">{{ $t('home.events.our-events') }}</p>
      <p class="text-sm md:text-base whitespace-pre-line">{{ $t('home.events.description') }}</p>
      <div class="flex justify-center md:justify-start w-full">
        <NuxtLink :to="localePath('/events')" class="w-full md:w-auto">
          <Button class="bg-tau-red mt-8 w-full xl:w-auto">
            <div>{{ $t('home.events.discover') }}</div>
          </Button>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const imageCount = 8;
const containerRef = ref(null);

const swiper = useSwiper(containerRef, {
  loop: true,
  pagination: true,
  navigation: true,
  slidesPerView: 1,
  injectStyles: [
    `.swiper-button-next, .swiper-button-prev {
width: 20px !important;
height: 20px !important;
color: #fff !important;
}`
  ],
  autoplay: {
    delay: 5000,
  },
  breakpoints: {},
});
</script>

<style scoped></style>
